import React from 'react';
import classnames from 'classnames';
import ReactModal from 'react-modal';
import {
    AnalyticsSenderProvider,
    useUpdateLocalSessionId,
    useDcbAutolink,
} from '@funtech-int/yango-shared';
import smoothscroll from 'smoothscroll-polyfill';
import { useRouteMatch } from '@funtech-int/rival-react';

import { useLoggedInAnalytics } from '@/app/hooks/useLoggedInAnalytics';
import { useRegisterAnalytics } from '@/app/hooks/useRegisterAnalytics';
import { dcbActivationScreenWidget } from '@/scenarios/dcb/widgets';
import { notificationsBlockWidget } from '@/scenarios/notifications/widgets';
import { Popups } from '@/shared/components/Popups/Popups';
import { clientOnlyWrapper } from '@/shared/lib/clientOnly';
import { profilesScreenWidget } from '@/scenarios/profiles/widgets';
import { useWidget } from '@/shared/hooks/useWidget';

import { useInitGtm } from '../../hooks/useInitGtm';
import { useLayoutProps } from '../../hooks/useLayoutProps';
import { Footer } from '../Footer/Footer';
import { Header } from '../Header/Header';
import { MovieModalProvider } from '../MovieModalProvider/MovieModalProvider';
import { BughunterContainer } from '../Bughunter/Bughunter';

import styles from './Layout.module.css';

if (typeof window !== 'undefined') {
    smoothscroll.polyfill();
}

export const ClientLayout = clientOnlyWrapper(({ children }) => {
    ReactModal.setAppElement('#app-container');
    const location = useRouteMatch();

    const shouldShowDcbActivationScreen = useDcbAutolink();

    const SubscriptionActivationScreen = useWidget(dcbActivationScreenWidget);
    const NotificationsBlock = useWidget(notificationsBlockWidget);
    const ProfilesScreen = useWidget(profilesScreenWidget);

    useUpdateLocalSessionId(location.id);

    useInitGtm();

    useRegisterAnalytics();
    useLoggedInAnalytics();

    const {
        withNotifications,
        shouldShowHeader,
        shouldShowFooter,
        headerType,
        shouldShowSubscribeButton,
        isFluid,
    } = useLayoutProps(location);

    if (shouldShowDcbActivationScreen) {
        return <SubscriptionActivationScreen />;
    }

    return (
        <div className={classnames(styles.root, { [styles.fluid]: isFluid })}>
            <AnalyticsSenderProvider>
                <ProfilesScreen header={<Header type="only-logo" />}>
                    <MovieModalProvider>
                        {shouldShowHeader ? (
                            <Header
                                type={headerType}
                                shouldShowSubscribeButton={shouldShowSubscribeButton}
                            />
                        ) : null}
                        <div className={styles.content}>{children}</div>
                        {shouldShowFooter ? <Footer /> : null}
                        <Popups />
                        {withNotifications && <NotificationsBlock />}
                    </MovieModalProvider>
                </ProfilesScreen>
            </AnalyticsSenderProvider>
            <BughunterContainer />
        </div>
    );
});
